export const DEFAULT_CONTAINER_STATE = {
  isReady: false,
  isBeingInitialized: false,
  error: null
};
